"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _Dot = _interopRequireDefault(require("../../primitives/Dot"));
var _Tag = _interopRequireDefault(require("../../primitives/Tag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Toolbar = () => {
  const ref = (0, _react.useRef)(null);
  const [width, setWidth] = (0, _react.useState)(300);
  (0, _react.useLayoutEffect)(() => {
    setWidth(ref.current.offsetWidth);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "hpd-toolbar",
    ref: ref,
    style: {
      left: "calc(50% - ".concat(width / 2, "px)")
    }
  }, /*#__PURE__*/React.createElement(_Dot.default, {
    status: "up",
    className: "ml-05em mr-05em"
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-text-secondary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "color-text font-weight-500"
  }, "25 "), "/ 28 systems running"), /*#__PURE__*/React.createElement("div", {
    className: "hpd-toolbar-divider"
  }), /*#__PURE__*/React.createElement(_Tag.default, {
    type: "green"
  }, "99.999%"));
};
var _default = exports.default = Toolbar;